import { useEffect } from "react";

import * as Sentry from "@sentry/react";

import ChargebeeCheckout from "../components/ChargebeeCheckout/ChargebeeCheckout";
import { CheckoutIntlProvider } from "../components/ChargebeeCheckout/CheckoutIntlProvider";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import { paymentPlatformSentryTag } from "../hooks/useAccount";

const CheckoutPage = () => {
  useEffect(() => {
    Sentry.setTag(paymentPlatformSentryTag, "chargebee");
  }, []);

  return (
    <CheckoutIntlProvider>
      <UnderMaintenanceOrChildren>
        <ChargebeeCheckout />
      </UnderMaintenanceOrChildren>
    </CheckoutIntlProvider>
  );
};

export default CheckoutPage;
